<template>
  <div class="main-page">
    <Menu
      title="好差评"
      :home="true"
    />
    <div class="container-flex wrap-list">
      <div
        class="left-list"
        v-if="list.length"
      >
        <div
          :class="['item',index==current?'active':''] "
          @click="getTab(index)"
          v-for="(news,index) in list"
          :key="'key-list'+index"
        >
          <div>
            {{news}}
          </div>
        </div>
      </div>
      <div class="right-con">
        <template v-if="current ===0">
          <div class="aid">
            <div class="title">
              我的办件
            </div>
            <div class="aidlist">
              <table>
                <thead bgcolor="#eee">
                  <tr>
                    <th width="320px">受理部门</th>
                    <th>办理时间</th>
                    <th>办理状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="list && list.length">
                    <tr
                      v-for="(item,index) in OfficeList"
                      :key="'list-'+index"
                    >
                      <td :title="item.matter">{{item.matter}}</td>
                      <td>{{item.submitTime}}</td>
                      <td>{{item.officeStatus}}</td>
                      <td
                        class="font-color"
                        @click="$router.push('/evaluation')"
                      >
                        <button class="no-evaluation">
                          {{item.operate}}
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <template v-if="!(list && list.length) ">
                <div class="imgs">
                  <img
                    src="wstatic/img/banner/messageNull.jpg"
                    alt=""
                  >
                </div>
              </template>
            </div>

          </div>
        </template>
        <template v-if="current ===1">
          <div class="aid">
            <div class="title">
              我的评价
            </div>

            <div class="my-evaluation">
              <table>
                <thead bgcolor="#eee">
                  <tr>
                    <th>序号</th>
                    <th width="320px">办事名称</th>
                    <th>受理部门</th>
                    <th>提交时间</th>
                    <th>评价状态</th>
                    <th>操作</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item,index) in evalustionLists">
                    <tr :key="'list-'+index">
                      <td>{{item.index}}</td>
                      <td>{{item.matter}}</td>
                      <td>{{item.acceptDepart}}</td>
                      <td>{{item.submitTime}}</td>
                      <td>{{item.evaluatStatus}}</td>
                      <template v-if="item.evaluatStatus === '待评价'">
                        <td class="font-color ">
                          <button
                            class="no-evaluation"
                            @click="$router.push('/evaluation')"
                          >
                            {{item.operate}}
                          </button>
                        </td>
                      </template>
                      <template v-if="item.evaluatStatus === '已评价'">
                        <td
                          class="font-color "
                          disabled="disabled"
                          @click="getSlideRight"
                        >
                          <button class="no-evaluation">
                            {{item.operate}}
                          </button>
                        </td>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </template>
      </div>
    </div>
    <Rightslide
      v-model="slide"
      @getClose="getClose"
    >
      <template slot="content">
        <div class="right-aid">
          <div class="look-evaluation">
            <div class="hts">法律援助律师工作证颁发</div>
            <table>
              <tr class="top-line">
                <td bgcolor="#fafafa">实施单位</td>
                <td class="lable">云南省司法厅</td>
                <td bgcolor="#fafafa">到现场办理的次数</td>
                <td class="lable">无特别说明</td>
              </tr>
              <tr>
                <td
                  bgcolor="#fafafa"
                  width="20%"
                >法定办结时限</td>
                <td class="lable">30日</td>
                <td bgcolor="#fafafa">办理时间</td>
                <td class="lable">2020-04-14 11:37:19</td>
              </tr>
              <tr>
                <td bgcolor="#fafafa">是否收费</td>
                <td class="lable">无特别说明</td>
                <td bgcolor="#fafafa">办理地点</td>
                <td class="lable">无特别说明</td>
              </tr>
            </table>
          </div>
          <div class="start-content">
            <div class="start-left">
              <div class="name">李邵波</div>
              <div class="start-box">
                <div
                  v-for="(n,index) in 5"
                  :key="'n'+index"
                  :class="['start-off',{'on':n<=cur}]"
                ></div>
                <span class="start-desc">{{evaluationDesc}}</span>
              </div>
            </div>
            <div class="start-right">
              2020-04-22 01:00:13
            </div>
          </div>
          <div class="checkbox-input">
            <label
              v-for="(item,index) in checkboxList"
              :key="'key-ass'+index"
              :class="{'checked':evaluation.evalType.indexOf(index) !== -1 }"
              class="disabled"
              :for="index"
            >
              <input
                type="checkbox"
                :id="index"
                class="weui-check "
                disabled
              >
              <div class="cells-check__icon" />
              <div class="cells-check__bd">
                <div class="cells-check__title">
                  {{item}}
                </div>
              </div>
            </label>
          </div>
          <div class="textarea">
            <div class="textarea-title">文字评价：</div>
            <textarea
              disabled
              class="disabled"
            >很好</textarea>
          </div>
        </div>
      </template>
    </Rightslide>
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import Rightslide from '../../components/RightSlide'
import { veryDissatisfied, dissatisfied, basicDissatisfied, satisfaction, verySatisfied } from './js/config.js'
export default {
  components: {
    Menu,
    Rightslide
  },
  data () {
    return {
      veryDissatisfied, // 非常不满意
      dissatisfied, // 不满意
      basicDissatisfied, // 基本满意
      satisfaction, // 满意
      verySatisfied, // 非常满意
      list: ['我的办件', '我的评价'],
      current: 0,
      slide: {
        show: false
      },
      OfficeList: [
        {
          matter: '法律援助律师工作证颁发测试',
          submitTime: '2019-08-12',
          officeStatus: '已办结',
          operate: '评价'
        },
        {
          matter: '法律援助律师工作证颁发测试',
          submitTime: '2019-08-12',
          officeStatus: '已办结',
          operate: '评价'
        },
        {
          matter: '法律援助律师工作证颁发测试',
          submitTime: '2019-08-12',
          officeStatus: '已办结',
          operate: '评价'
        }
      ],
      evalustionLists: [
        {
          index: 1,
          matter: '法律援助律师工作证颁发测试',
          acceptDepart: '云南省司法厅',
          submitTime: '2019-08-12',
          evaluatStatus: '待评价',
          operate: '评价'
        },
        {
          index: 2,
          matter: '法律援助律师工作证颁发测试',
          acceptDepart: '云南省司法厅',
          submitTime: '2019-08-12',
          evaluatStatus: '已评价',
          operate: '查看详情'
        },
        {
          index: 3,
          matter: '法律援助律师工作证颁发测试',
          acceptDepart: '云南省司法厅',
          submitTime: '2019-08-12',
          evaluatStatus: '已评价',
          operate: '查看详情'
        }
      ],
      cur: -1,
      evaluationDesc: '',
      checkboxList: [],
      evaluation: {
        evalType: []
      },
      arr: [],
      startType: 3
    }
  },
  created () {
    console.log(this.cur)
    this.getStartNum()
  },
  methods: {
    getTab (index) {
      $('.right-con').scrollTop(0, 2000); // eslint-disable-line
      this.current = index
    },
    getSlideRight () {
      this.slide.show = true
    },
    getClose () {
      this.slideShow = false
    },
    getStartNum () {
      if (this.startType === 1) {
        this.cur = this.startType
        this.evaluationDesc = '非常不满意'
        this.checkboxList = this.veryDissatisfied
        this.getEvalType()
      } else if (this.startType === 2) {
        this.cur = this.startType
        this.evaluationDesc = '不满意'
        this.checkboxList = this.dissatisfied
        this.getEvalType()
      } else if (this.startType === 3) {
        this.cur = this.startType
        this.evaluationDesc = '满意'
        this.checkboxList = this.basicDissatisfied
        this.getEvalType()
      } else if (this.startType === 4) {
        this.cur = this.startType
        this.evaluationDesc = '基本满意'
        this.checkboxList = this.satisfaction
        this.getEvalType()
      } else if (this.startType === 5) {
        this.cur = this.startType
        this.evaluationDesc = '非常满意'
        // this.checkboxList = this.verySatisfied
        // this.getEvalType()
      }
    },
    getEvalType () {
      this.evaluation.evalType = []
      this.checkboxList.forEach((e, i) => {
        this.evaluation.evalType.push(i)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.wrap-list
  height 100%
  display flex
  justify-content center
  padding 0.09rem 0.6rem 0.5rem
table
  width 93%
  // border-collapse collapse
  font-size 0.22rem
  margin 0 auto
  color #192d46
  table-layout fixed
thead
  tr
    border-bottom none
td, th
  line-height 0.6rem
  text-align center
  font-weight 400
td
  overflow hidden
  white-space nowrap
  text-overflow ellipsis
  border-bottom 1px solid #eee
tbody
  tr
    width 100%
    height 0.6rem
    border-bottom 1px solid #b4c3ca
    &:nth-child(even)
      background #f8f8f8
  .font-color
    color #f29530
    cursor pointer
    .no-evaluation
      background #f29530
      border-color #f29530
      color #fff
      border-radius 0.03rem
      font-size 0.2rem
      line-height 0.3rem
      padding 0.05rem 0.15rem
.left-list
  width 5rem
  height 100%
  margin-right 0.48rem
  background-color rgba(255, 255, 255, 0.2)
  border-radius 0.1rem
  border solid 1px rgba(255, 255, 255, 0.2)
  padding-bottom 1.3rem
  overflow-y scroll
  webkit-overflow-scrolling touch
  &::-webkit-scrollbar
    display none
    width 0 !important
  .item
    border-bottom solid 1px rgba(255, 255, 255, 0.2)
    color #fff
    padding 0.2rem
    line-height 1.6
    font-size 0.26rem
    &.active
      background #f29530
      border 0
.right-con
  position relative
  height 100%
  width 12.46rem
  overflow-y scroll
  background #fff
  border-radius 0.1rem
  webkit-overflow-scrolling touch
  box-sizing border-box
  &::-webkit-scrollbar
    display none
    width 0 !important
  .aid
    background-color #fff
    padding-bottom 0.46rem
  .title
    height 0.7rem
    font-size 0.3rem
    line-height 0.7rem
    color #333
    font-family MicrosoftYaHei-Bold
    padding-left 0.3rem
    background-color #fbfbfb
    box-shadow 0px 1px 0px 0px #e5e5e5
  .aidlist, .my-evaluation
    // padding-left 20px
    margin-top 0.4rem
.right-aid
  width 8rem
  background-color #fff
.look-evaluation
  margin-top 0.2rem
  padding 0 0.3rem
  .hts
    font-size 0.3rem
    line-height 1
    font-weight 600
    color #333
    padding 0.2rem 0.4rem 0.48rem 0
  table
    width 100%
    border-collapse collapse
    font-size 0.18rem
    margin 0 auto
    border 1px solid #f0f0f0
  td
    text-align center
    padding 0.14rem 0
    border 1px solid #f0f0f0
    font-weight 600
    line-height 0.2rem
    &.lable
      font-weight normal
  tr
    width 100%
.start-content
  padding 0 0.3rem
  margin-top 0.2rem
  display flex
  justify-content space-between
  .start-left
    display flex
    .name
      font-size 0.18rem
      margin-top 0.06rem
    .start-box
      display flex
      margin-left 0.54rem
      .start-off
        width 0.41rem
        height 0.39rem
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAADSklEQVRogd3aT6hUZRjH8c8d7Q9EoEhJFNdLpF3DQsukIoKk//8Iw1ZuhJZFSLgRo+siXGVURLVr0yaIEENoEf1RA4tKK7IgqKDLhXtdXMtu4Z9s8cyU2cycd877Hgf7bmaY85z3/f3mOXPmed7zjkxNH9EgD2MrVuAnPI/XcKqJyVpNDNpmC97GDbgAy/CKMNQIIw1lZjU+wUiP4+uE0aI0lZkJvY3Ay1hYetImzKzB/RUxl2F76YmbMDORGPcYri05cWkzN+HexNh5eK7k5KXNTAwYfyfuKzV5STO34O4a5z2r/80imZJmJmqetxLrSwgoZeZWccnUZRvm54ooZWZb5vnj2JArooSZ27C2wDjP4PycAQZJ7cUYw5L262j7/c05Ak5jDLvwPg7gK0wOMkC32myhqK2uE+kfx3IsytNaixlh7At8iYP4Fie6BXfMLMDjeFSU60VulQ3xB74Wxg7iHfxAmBkVqb1yaPLyOIGXsHm+6C/OVSPE734TDo9MTR85iouGLKgEky2cHLaKQixqYf+wVRTi05bo+v4PvNDCTuwetpJM3sRbnXJmPd4bopgc9mMj/9Rmc3hI/N+cS3yPB4X+fxWac3gAHw5BVB1+Fi36TOeDM6vmOdHGfnQWRdVhBneJzPxNtxagY2jPWRBVh1nRCB4680CvfuY3YWhvg6LqMIs7RIH5H/o1Z0eFoX0NiKpDx8hnvQKqOs1fhaGPC4qqQ6UR0trmX/BICUU1OS7BCOlrAJdmycnjPHyXEphq5ur6WopwVUpQqpllGUJKsDwlKNXMeIaQEixNCUo1kzRYgyRdGalmxurrKEKxzFyIxXlasimWmSWZQkqwAJdUBaWYuTxfSxEqs5NiZhjLst2o/N2kmMn995/Ek+K5f87OjCKZqbxWezArdmksxYtiI8P1YgGljqkimRmUY9jRnnw7fj/t2AGxn2a1eHwxCGNVASlmfkyc7E+8IS6Hp3C4T+znYgHldgnVcJt5VQEpZnaLRq0f74pve4PYvZTKB7hRLBVNVcR+UzVYiplpPKH7mvQe0Y/fIx4I1eEUXsc1YpPDsS4xJ/Fq1UCD7GpaJRYLF4tvf5f6Bvoxis1i2esKsXDxtLhx9OUvchGVZ7PK7FMAAAAASUVORK5CYII=') no-repeat 0 center / 0.41rem 0.39rem
        margin-right 0.15rem
        cursor pointer
        &.on
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAADP0lEQVRogd2aSWgUURCGvywuFyEhqIiSBNGYiIpLFBURFPcNF8wpF8GTKCKSiygmoHhSUQnqzYsXQYIoAQ/iEhVE1LjgAgEVDILjIUSN4s6TmjDOZLqru6snM/mhSZh+S31dr7urql9Rb+tMYtRGYD8wDXgLHAfOAn/imLI4RpB9QBswBxgB1ACnBSgWxQVTDxzKcm43sKmQYJqBIo/zrUC59aRxwMwD1vq0GQccsZ44DphmZbvtwHTLia1h5gOrlW1LgKOWk1vDaL2S1HJgjdXkljALgZUh+h32eVioZQkT1CtJubf2VgsDrGAWyZIJqxagNKoRVjAtEfvXAo1RjbCAWQwsNRjnIDA8ygBBXDsKqAaq5G+l/L8gigEpcmNeBq4DncBToDvIAAPBlEtsNUPc7446oMLIaC+tkCOphIA9Ap4Aj4GXwE8vmDJgJ9Ag4brJo9JAo+XBkvpw+QY8EzB3XAFeuxMun6kU107ME4Cgcl46BTSVSn5RqCDI6toDfCwO+dbOR+1wML+GCEyFg7mXB4ZY6H6xZH1DQScczCWgvcBhLgAXk+GMi1qvDbJBYeVuk22kxGZ9wAZ53xSSuoD1Yv9/gab7YR1ws0Bg3kmKnkj+kB4190kaeyv3tgVSQmK4rtROA6UASaCO/GP4px6J1V6kn8iWz3wRoNvx2xZIDmSZBJgZ8krOPgvQnTwDeZCtgV+m+UmA7trbFki+ICjT5l5gS+7t79cPDQgBagBjbOwKpWHAK01HLcyU3NqfoUmaRlqYGju7QqlO00kLU5tb2zM0WdNIC6MaLEapVoYWpnqQYcw8MxIYG92eSDLzTNXgMfSrTGpontLAjI/fVpV8vaOByUVZViPf+0YDE/Xt3y3f/tsi7sww8YzvWs2iHtml4a7oSWAzMFsKKGGgTDwTVN+BYzK5+9b/NaV/p+ynqZfPF0Hk+3rQwLxRTvgbOC/LYa+r/Xq0fSgFlCWaaFhU4tdAA9MuiZqXrsrVbpTdS1rdAOZKqei9T5/nFjAfgF1ZatIdko+vkg9CYeTun3PAVNnk4JZputzcZ/zGDrLfbJYUC1004K6+W/NhAbzkvhc1SdlrghQuDsiDI7uAv8yVhrYyOzUXAAAAAElFTkSuQmCC') no-repeat 0 center / 0.41rem 0.39rem
      .start-desc
        line-height 0.42rem
        font-size 0.2rem
        font-weight 400
        color #f29530
  .start-right
    font-size 0.18rem
    margin-top 0.1rem
.textarea
  display flex
  margin-top 0.3rem
  padding 0 0.3rem
  .textarea-title
    font-size 0.18rem
    width 0.9rem
    padding 0.1px 0 0.1rem 0
  textarea
    width 85%
    height 1.5rem
    border-radius 0.03rem
    border 1px solid #c4b8b8
    background rgba(255, 255, 255, 0.2)
    padding 0.1rem
    font-size 0.16rem
    outline none
    &.disabled
      color #ccc
      cursor not-allowed
      background-color #f3f3f3
      border-color #ddd
.checkbox-input
  margin-top 0.25rem
  padding 0 0.3rem
  margin-left 1.1rem
  label
    display flex
    // cursor pointer
    margin-bottom 0.15rem
    &.disabled
      cursor not-allowed
    &.checked
      .cells-check__icon
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABKElEQVQ4ja3UvUvDQBzG8W+Sa1pjlxZBcHBw6SBoBzs4qjgIYkFwkTr5trkpdOjiqA6CdBAEBds/QjsJOrj5B+jsZITaNrTWxCEWfDltz+QZf3f34Q6OR6sW0yawD+SAJGp5Bs6BbQHsAVuKQCeJj7OODqz8E/mcdR3158iS1ENAAFCGIqkF4mvXwaHYVAHPeQoGxVev8F4b1MvZ7pAxPClFrMVTNLOf2tmsdP0HZM0dYmWPv8yimU2MwXGcyzy8tXqDWncljKEMfTO7/g0HUpgTG7TvL2g/VKQIgPg+aN4egYhiji0Tc13EyDTuyyNOJf8rIoUAmjcHaIYgMrqE17Cpl+b/RAC0ajHtdd3VQ0L92XYIjq3j90nQnAhgB9Dw6yShCHSKrfAOLm1CEDXJmEAAAAAASUVORK5CYII=') no-repeat center
    input
      opacity 0
    .cells-check__icon
      width 0.2rem
      height 0.2rem
      flex-shrink 0
      margin-right 0.1rem
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAj0lEQVQ4je3UIQ7CQBCF4W8rCAJDr0C4FdcARwhIMNyBY5EegSLapEUtogsCt5WkfzJmkvdnzLzQdHGGCzYo5fHEDdsCZ0SsETJnlbKn0HTxkSR15jUfStxD08WY7KNYzGl7sRgr+GUSTaL/FdXy6+NL2ytRh6aL17Q7GvolhyUOeBXYGb6/MnRLzlQpu38DuegvLcjd0yMAAAAASUVORK5CYII=') no-repeat center center
      background-size 0.2rem
    .cells-check__title
      font-size 0.17rem
      line-height 0.2rem
      color #333
</style>
